// import React, { useEffect, useState } from 'react';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import './embla.css';
import { getCachedMediaUrl } from '../../../../../../lib/utils/utils';
import { DotButton, useDotButton } from './EmblaCarouselDotButton';

Autoplay.globalOptions = {
    delay: 8000
}

function CarouselBanner({ item, options }) {
    const [emblaRef, emblaApi] = useEmblaCarousel(options, [Autoplay()]);

    const { selectedIndex, scrollSnaps } = useDotButton(
        emblaApi,
    );

    return (
        <section className="embla relative">
            <div className="embla__viewport" ref={emblaRef}>
                <div className="embla__container">
                    {item.item.imageLinkList?.map((slide, index) => {
                        return (
                            <div className="embla__slide w-full" key={index}>
                                <img className='w-full h-auto cursor-pointer' src={getCachedMediaUrl(slide.imageLink)} alt={slide.altText} />
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className="embla__controls">
                <div className="embla__dots">
                    {scrollSnaps.map((_, index) => (
                        <DotButton
                            key={index}
                            className={'embla__dot'.concat(
                                index === selectedIndex ? ' embla__dot--selected' : ''
                            )}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default CarouselBanner;
